<div class="br-page">
  <div class="br-outer">

    <!-- ==============================
         LOADED STATE
         ============================== -->
    <ng-container *ngIf="blog; else loading">

      <!-- Back Button -->
      <div class="br-back-wrap">
        <button class="br-back-btn" [routerLink]="['/blogs']">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2.5"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          <span>Back to Blogs</span>
        </button>
      </div>

      <!-- Two-column layout: article + sidebar -->
      <div class="br-layout">

        <!-- ===== LEFT: ARTICLE ===== -->
        <article class="br-article">

          <!-- Publication Info -->
          <div class="br-pub-header">
            <span class="br-pub-date">
              {{ blog.publishedDate | date: 'MMM d, yyyy' }}
            </span>
            <div class="br-pub-divider"></div>
            <span class="br-pub-author">By {{ blog.author || 'SEHYOG Academy' }}</span>
          </div>

          <!-- Title -->
          <div class="br-title-wrap">
            <h1 class="br-title">{{ blog.title }}</h1>
            <p class="br-subtitle" *ngIf="blog.subtitle">{{ blog.subtitle }}</p>
          </div>

          <!-- Tags -->
          <div class="br-tags" *ngIf="blog.tags && blog.tags.length">
            <span class="br-tag" *ngFor="let tag of blog.tags">{{ tag }}</span>
          </div>

          <!-- Banner Image -->
          <div class="br-banner">
            <img [src]="blog.image" [alt]="blog.title" />
          </div>

          <!-- Content -->
          <div class="br-content-wrap">
            <section class="br-section">
              <h2 class="br-section-title">Introduction</h2>
              <div class="br-prose" [innerHTML]="blog.description"></div>
            </section>
            <!-- Add more <section class="br-section"> blocks here as needed -->
          </div>

          <div class="br-divider"></div>

          <!-- Footer Meta Bar -->
          <div class="br-meta-bar">
            <div class="br-meta-author">
              <div class="br-author-avatar">
                {{ (blog.author || 'SA').charAt(0) }}
              </div>
              <div class="br-author-info">
                <p>Written by</p>
                <strong>{{ blog.author || 'SEHYOG Academy' }}</strong>
              </div>
            </div>

            <div class="br-share-row">
              <span class="br-share-label">Share</span>

              <!-- Twitter / X -->
              <button class="br-share-btn" title="Share on X" (click)="shareOn('twitter')">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </button>

              <!-- Facebook -->
              <button class="br-share-btn" title="Share on Facebook" (click)="shareOn('facebook')">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </button>

              <!-- LinkedIn -->
              <button class="br-share-btn" title="Share on LinkedIn" (click)="shareOn('linkedin')">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </button>

              <!-- Copy link -->
              <button class="br-share-btn" title="Copy link" (click)="copyLink()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5"
                     stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="br-divider"></div>

<section class="blog-comment-section">

  <h2>Leave a Comment</h2>

  <form
    [formGroup]="commentForm"
    (ngSubmit)="submitComment()">

    <div class="comment-grid">

      <input
        type="text"
        placeholder="Your Name"
        formControlName="name">

      <input
        type="email"
        placeholder="Your Email"
        formControlName="email">

    </div>

    <input
      type="text"
      placeholder="Phone Number"
      formControlName="phone">

    <textarea
      rows="5"
      placeholder="Write your comment"
      formControlName="comment">
    </textarea>

    <button
      type="submit"
      [disabled]="submittingComment">

      {{
        submittingComment
          ? 'Submitting...'
          : 'Submit Comment'
      }}

    </button>

  </form>

</section>

<section
  class="blog-approved-comments"
  *ngIf="comments.length">

  <h2>
    Comments ({{ comments.length }})
  </h2>

  <div
    class="comment-card"
    *ngFor="let item of comments">

    <div class="comment-header">
  <strong>{{ item.name }}</strong>
  <span>{{ item.created_at | date:'dd MMM yyyy' }}</span>
</div>

    <p>
      {{ item.comment }}
    </p>

  </div>

</section>


        </article>

        <!-- ===== RIGHT: SIDEBAR ===== -->
        <aside class="br-sidebar">

          <!-- Table of Contents -->
          <div class="br-sidebar-card">
            <div class="br-sidebar-card-header">
              <div class="br-sidebar-card-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5"
                     stroke-linecap="round" stroke-linejoin="round">
                  <line x1="8" y1="6" x2="21" y2="6"/>
                  <line x1="8" y1="12" x2="21" y2="12"/>
                  <line x1="8" y1="18" x2="21" y2="18"/>
                  <line x1="3" y1="6" x2="3.01" y2="6"/>
                  <line x1="3" y1="12" x2="3.01" y2="12"/>
                  <line x1="3" y1="18" x2="3.01" y2="18"/>
                </svg>
              </div>
              <h3 class="br-sidebar-card-title">Contents</h3>
            </div>
            <ul class="br-toc-list">
              <li class="br-toc-item">
                <a class="br-toc-link" href="#introduction">Introduction</a>
              </li>
              <!-- Dynamically add more TOC items here to match your sections -->
            </ul>
          </div>

          <!-- CTA Card -->
          <div class="br-cta-card">
            <h3 class="br-cta-card-title">Ready to boost your grades?</h3>
            <p class="br-cta-card-text">
              Get expert tuition in 11+, GCSE and A-Level from Sehyog's qualified teachers.
            </p>
            <a href="/contact" class="br-cta-card-btn">Book a Free Demo</a>
          </div>

          <!-- Tags Card -->
          <div class="br-sidebar-card" *ngIf="blog.tags && blog.tags.length">
            <div class="br-sidebar-card-header">
              <div class="br-sidebar-card-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5"
                     stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                  <line x1="7" y1="7" x2="7.01" y2="7"/>
                </svg>
              </div>
              <h3 class="br-sidebar-card-title">Tags</h3>
            </div>
            <div class="br-tags-card-body">
              <div class="br-tags-card-tags">
                <span class="br-tag" *ngFor="let tag of blog.tags">{{ tag }}</span>
              </div>
            </div>
          </div>

        </aside>

      </div><!-- /br-layout -->

    </ng-container>

    <!-- ==============================
         LOADING STATE
         ============================== -->
    <ng-template #loading>
      <div class="br-loading">
        <div class="br-loading-card">
          <div class="br-spinner"></div>
          <p class="br-loading-text">Loading article...</p>
        </div>
      </div>
    </ng-template>

  </div>
</div>